module.exports = __webpack_public_path__ + "img/Pouring_the_liquid.2664f89a.png";